import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GetArticlesCacheKey } from '../queries/useGetArticlesQuery/useGetArticlesQuery';

enum DeleteArticleCacheKey {
  DeleteArticle = 'DeleteArticle',
}

export const useDeleteArticleMutation = () => {
  const { deleteArticle } = useServicesContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DeleteArticleCacheKey.DeleteArticle],
    mutationFn: ({ id }: { id: number }) => deleteArticle(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetArticlesCacheKey.GetArticles],
      });
    },
  });
};
